<template>
  <div class="product-card">
    <div class="product-card__quick-actions">
      <b-form-checkbox class="custom-control-primary"> </b-form-checkbox>
      <div class="pin-icon">
        <inline-svg
          :src="require('@/assets/images/icons/dashboard/pin.svg')"
          :class="{ active: product.isPinned }"
          @click="product.isPinned = !product.isPinned"
        />
      </div>
    </div>
    <div class="product-card__container">
      <div class="product-card__img" @click="$bvModal.show('gallery-modal')">
        <img
          :src="require(`@/assets/images/slider/${product.image}`)"
          alt="product image"
          class="product-img"
        />
        <span class="offer-icon">
          <img
            :src="require(`@/assets/images/icons/dashboard/offer.png`)"
            alt="offer icon"
          />
        </span>
      </div>
      <div class="row flex-grow-1">
        <div class="col-4 col-lg-4 mb-1 mb-lg-0">
          <div class="d-flex mb-1">
            <b-input-group class="px-0 col-5">
              <b-input-group-prepend is-text> # </b-input-group-prepend>
              <b-form-input placeholder="رقم الكود" :value="product.code" />
            </b-input-group>
            <b-input-group class="px-0 col ml-1">
              <b-input-group-prepend is-text>
                <inline-svg
                  :src="require('@/assets/images/icons/dashboard/layer-2.svg')"
                />
              </b-input-group-prepend>
              <b-form-select :options="options" :value="null" />
            </b-input-group>
          </div>
          <b-input-group>
            <b-input-group-prepend is-text>
              <inline-svg
                :src="require('@/assets/images/icons/dashboard/layer.svg')"
              />
            </b-input-group-prepend>
            <b-form-input placeholder="الاسم" :value="product.name" />
          </b-input-group>
        </div>
        <div class="col-4 col-lg-4 px-lg-0">
          <div class="d-flex">
            <div class="px-0 col">
              <div class="checkbox-container gray-bg mb-1">
                <span class="checkbox-container__label">الكمية محددة</span>
                <b-form-input
                  placeholder="000"
                  :disabled="!product.showQuantity"
                  v-model="product.quantity"
                />
                <b-form-checkbox
                  :checked="product.showQuantity"
                  @change="toggleShowingQuantity"
                ></b-form-checkbox>
              </div>
              <b-input-group>
                <b-input-group-prepend is-text>
                  <inline-svg
                    :src="
                      require('@/assets/images/icons/dashboard/layer-2.svg')
                    "
                  />
                </b-input-group-prepend>
                <b-form-select :options="options" :value="null" />
              </b-input-group>
            </div>
            <div>
              <div class="checkbox-container ml-1 mb-1">
                عرض بالمتجر
                <b-form-checkbox
                  :checked="product.viewInStore"
                ></b-form-checkbox>
              </div>
              <div class="checkbox-container ml-1">
                عرض بالمنصة
                <b-form-checkbox
                  :checked="product.viewInPlatform"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 col-lg-4">
          <div class="d-flex">
            <div class="px-0 col">
              <div class="checkbox-container text-green mb-1">
                <span :class="{ 'opacity-50': product.isActive }">غير نشط</span>
                <b-form-checkbox
                  name="check-button"
                  switch
                  inline
                  :checked="product.isActive"
                  @change="product.isActive = !product.isActive"
                >
                </b-form-checkbox>
                <span :class="{ 'opacity-50': !product.isActive }">نشط</span>
              </div>
              <div class="d-flex">
                <button
                  class="btn btn--light-green flex-grow-1"
                  @click="$bvModal.show('locations-modal')"
                >
                  أماكن العرض
                </button>
                <button class="btn btn--light-green ml-1">
                  <inline-svg
                    :src="
                      require('@/assets/images/icons/dashboard/folder-add.svg')
                    "
                  />
                </button>
              </div>
            </div>
            <div class="ml-1">
              <button
                class="btn btn--light-green col mb-1"
                @click="$bvModal.show('product-form-modal')"
              >
                المزيد
              </button>
              <button class="btn btn--gradient-green col">حفظ</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormSelect,
  BFormCheckbox,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
} from "bootstrap-vue";

export default {
  name: "ProductCard",
  props: {
    product: {
      required: true,
      type: Object,
    },
  },
  components: {
    BFormSelect,
    BFormCheckbox,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
  },
  data() {
    return {
      options: [
        { value: null, text: "اختر النوع", disabled: true },
        { value: "1", text: "option 1" },
        { value: "2", text: "option 2" },
      ],
    };
  },
  methods: {
    toggleShowingQuantity(val) {
      console.log(val);
      if (!val) {
        this.product.quantity = null;
        this.product.showQuantity = false;
      } else {
        this.product.showQuantity = true;
      }
    },
  },
};
</script>
